// Kept in its own dependency-free module so it can be unit tested without pulling in
// RaffleEditView.tsx's full transitive tree (RJSF, raffle content-field schemas, Firebase
// init, etc. — see RaffleEditView.test.ts for why that matters).
export const formatImageUploadProgressMessage = (uploaded: number, total: number) =>
  `Uploading raffle images (${uploaded}/${total})...`

// handleUpload() re-uploads and returns a fresh Storage URL whenever `image !== prevValue`.
// A freshly picked/dropped image always arrives as a base64 data URL, so passing the
// previously saved (already-hosted) URL as prevValue in that case would make handleUpload
// treat it as unchanged. Passing undefined instead forces the re-upload.
export const resolveImageUploadPrevValue = (
  nextValue: string,
  prevValue: string | undefined,
) => (/^data:image\//.test(nextValue) ? undefined : prevValue)
